var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '../../../../themes';
import { buildDatePickerProps } from '../../modifiers';
import * as S from './styles';
export var WeekDays = function (_a) {
    var weekDays = _a.weekDays, style = _a.style;
    var theme = useTheme();
    var styles = buildDatePickerProps({ weekTextStyle: style }, theme);
    return (_jsx(S.Container, __assign({ style: styles.weekTextStyle }, { children: weekDays.map(function (day) { return (_jsx("div", { children: day.slice(0, 3) }, day)); }) })));
};
